/***************************************************************************************
* FileName      : AdjustRow.js
* Description   : 해와관리자 > 정산 > 부가세내역 > AdjustRow 컴포넌트
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2023.12.14
* Modifide Date : 
* Reference     : 
***************************************************************************************/
import React, { useState , useEffect } from 'react';
import { Modal } from 'react-bootstrap';

export const AdjustRow = ({ Adjust }) => {
 
  return (
    <>
      <>
        <tr>
          <td> <input type="checkbox" /> </td>
          <td>{Adjust.month}</td>
          <td>{Adjust.vendor}</td>
          <td>{Adjust.taxable_sum}</td>
          <td>{Adjust.nontaxable_sum}</td>
          <td>{Adjust.card_sales_sum}</td>
          <td>{Adjust.income_sales_sum}</td>
          <td>{Adjust.expenditure_sales_sum}</td>
          <td>{Adjust.none_sales_sum}</td>

         </tr>
      </>
    </>
  );
};
